import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { CandidateComment } from '../../class/candidate-comment';

@Injectable()
export class CandidateCommentService extends WebService {

    public getCandidateComment (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('created_by,candidate,termination,candidate_exclusion,candidate_citation_contract_process'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/candidate-comments?${params}`, options);
    }

    public getCandidateCommentByRequisition (id: number,
        page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('created_by,candidate,termination,candidate_exclusion,candidate_citation_contract_process'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/candidates/${id}/candidate-comments?${params}`, options);
    }

    public newCandidateComment(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/candidate-comments`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateCandidateComment(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/candidate-comments/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteCandidateComment(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/candidate-comments/${id}`, { headers: this.headers } );
    }

    public infoCandidateComment(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/candidate-comments?id=${id}`,  { headers: this.headers } );
    }

    public validationCandidateId(candidate_id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/candidate-comments-validation?candidate_id=${candidate_id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/candidate-comment/candidate-comment.service.ts